import { persistReducer, Storage } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { AppAction, AppState } from './AppModel'

const initialState: AppState = {
  title: '',
  sidebarCollapsed: false,
  tabs: [],
  activeTab: 0,
  lang: undefined,
  langs: [],
  translationVersions: {},
  lastPage: '',
  country: '',
  app: 'e3dc',
  moreActive: false,
  appSettingsOpen: false,
}

function appReducer(state: AppState = initialState, action: AppAction): AppState {
  if (action.type === 'APP_UPDATE') {
    return { ...state, ...action.payload }
  }
  return state
}

const persistConfig: { key: string; storage: Storage; whitelist: (keyof AppState)[] } = {
  key: 'app',
  storage: storage,
  whitelist: ['lang', 'lastPage', 'country', 'translationVersions', 'isLogoutActive'],
}

export default persistReducer(persistConfig, appReducer)
